import { Navigate, Outlet } from 'react-router-dom';
import { hasClinicScope } from '@/application/auth/clinicScope';
import { LoadingBlock } from '@/presentation/components/common/LoadingBlock';
import { EmptyScopeShell } from '@/presentation/layouts/EmptyScopeShell';
import { useAuth } from '@/presentation/contexts/useAuth';

export function ProtectedRoute() {
  const { user, bootstrapping } = useAuth();

  if (bootstrapping) {
    return (
      <div className="flex h-full min-h-0 items-center justify-center overflow-y-auto bg-gray-100 dark:bg-gray-950">
        <LoadingBlock minHeightClassName="min-h-0" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!hasClinicScope(user.scope.allowedTenantIds)) {
    return <EmptyScopeShell />;
  }

  return <Outlet />;
}
